export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified my mother would need a nursing home. After day 5 with The Age-in-Place Blueprint I could structure her complete daily care routine without help. By week 3 I was managing her medications, exercises and nutrition with real confidence. This system literally saved our family $4,500 a month. Game-changer.',
    name: 'Margaret T.',
    location: 'New York · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      "I managed my father's care for 2 years frustrated because nothing seemed to stop his decline. I tried online courses for 6 months with no real framework. The Age-in-Place Blueprint actually works. I am now coaching other families through safe progressions and preventing falls, hospitalizations and premature institutionalization.",
    name: 'David L.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      "I was afraid I wasn't “qualified enough” to manage my mother's Alzheimer's care at home. The Blueprint proved me wrong. The visual method makes everything so clear. I felt confident from DAY ONE, which kept me motivated. I recommend it to every caregiver I know.",
    name: 'Susan P.',
    location: 'Melbourne · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The tracking sheets live on my bedside table now. I assess my mother on Monday and I already know which activities and exercises to assign before the week ends. I manage her care confidently now without guilt.',
    name: 'James R.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
  {
    quote:
      "The Expert Care Companion did it in three days. I had tried YouTube protocols for six months and always felt lost. Seeing the Alzheimer's management framework explained visually finally made clinical sense and I could actually help.",
    name: 'Emma T.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'The 6-volume calendar is what kept me consistent. 30 minutes a day learning one protocol, no guessing what to study. Week 4 I implemented my first complete care system and my father showed real improvement in mobility and memory.',
    name: 'Luis M.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
  {
    quote:
      'I bought it for the fall prevention protocols. Other caregivers review your case planning and share real solutions. Worth far more than $27.',
    name: 'Rachel P.',
    location: 'Auckland · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
